import { Component } from '@angular/core';

import { AuthService } from '@app/services';
import { User } from '@app/model';

@Component({
  selector: 'app-root',  // -> gerta uma tag html que é o que vai ser chamado no index.html
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']


})
export class AppComponent {
  title = 'Tripod Interface';

  user: User;

  constructor(private authService: AuthService) {
  }

  afterLogin() {
    this.user = this.authService.userValue;
  }

  logout() {
      this.authService.logout();
  }
}


// imports do components.module.ts

/*
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  //declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent
  ]
})
export class ComponentsModule { } */
